import { css } from "@emotion/css";
import { TagGroup, type TagProps } from "@octopusdeploy/design-system-components";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import pluralize from "pluralize";
import { useState } from "react";
const styles = {
    container: css({
        display: "flex",
        alignItems: "center",
        gap: space[8],
        flexWrap: "wrap",
    }),
    moreText: css({
        cursor: "pointer",
        color: themeTokens.color.text.link.default,
        font: text.body.bold.xSmall,
        fontWeight: 700,
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    }),
};
type ExpandingTagListProps<TId> = {
    singularName: string;
    ids: TId[];
    renderTagList: (ids: TId[]) => TagProps[];
};
export const ExpandingTagList = <TId,>({ singularName, ids, renderTagList }: ExpandingTagListProps<TId>) => {
    const [showAll, setShowAll] = useState<boolean>(false);
    if (!ids || ids.length === 0) {
        return <span />;
    }
    const tagProps = renderTagList(ids);
    if (tagProps.length === 0) {
        return;
    }
    else if (showAll || tagProps.length === 1) {
        return <TagGroup tags={tagProps}/>;
    }
    const visibleTags = tagProps.slice(0, 1);
    const remainingCount = tagProps.length - 1;
    return (<div className={styles.container}>
            <TagGroup tags={visibleTags}/>
            <a className={styles.moreText} onClick={() => setShowAll(true)} role="button" tabIndex={0} onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setShowAll(true);
            }
        }}>
                +{remainingCount} {pluralize(singularName, remainingCount)}
            </a>
        </div>);
};
